var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0C7.61126 0 0 7.61126 0 17C0 26.3887 7.61126 34 17 34C26.3887 34 34 26.3887 34 17C34 7.61126 26.3887 0 17 0ZM9.93116 16.9526C9.70633 16.7431 9.40895 16.629 9.10169 16.6344C8.79442 16.6398 8.50125 16.7643 8.28395 16.9816C8.06664 17.1989 7.94217 17.4921 7.93675 17.7994C7.93133 18.1066 8.04538 18.404 8.25488 18.6288L12.9991 23.373C13.2215 23.5951 13.5229 23.7199 13.8372 23.7199C14.1515 23.7199 14.453 23.5951 14.6753 23.373L25.7451 12.3033C25.9546 12.0784 26.0687 11.781 26.0633 11.4738C26.0578 11.1665 25.9334 10.8733 25.7161 10.656C25.4987 10.4387 25.2056 10.3143 24.8983 10.3088C24.591 10.3034 24.2937 10.4175 24.0688 10.627L13.8372 20.8586L9.93116 16.9526Z",
    fill: "#FE6F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_1502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCheck);
export default __webpack_public_path__ + "static/media/modal_check.8aa13751a608b0f546e3f11d74ea1285.svg";
export { ForwardRef as ReactComponent };